<template>
  <d-modal-confirmation
    :title="modalTitle"
    :text="modalConfirmationText"
    :modal="modal"
    :submitButtonText="modalSubmitButtonText"
    @closeModal="handleCloseModal"
    @submitModal="handleSubmitModal"
    :isSubmitting="isSubmitting"
  >
  </d-modal-confirmation>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    modalTitle() {
      return this.$t("coupons.change-status.title", {
        action: this.item.isActive
          ? this.$t(`coupons.change-status.button.deactivate`)
          : this.$t(`coupons.change-status.button.activate`),
      });
    },
    modalConfirmationText() {
      return this.$t("coupons.change-status.text", {
        action: this.item.isActive
          ? this.$t(`coupons.change-status.button.deactivate`).toLowerCase()
          : this.$t(`coupons.change-status.button.activate`).toLowerCase(),
        title: this.item.title,
      });
    },
    modalSubmitButtonText() {
      return this.item.isActive
        ? this.$t(`coupons.change-status.button.deactivate`)
        : this.$t(`coupons.change-status.button.activate`);
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
    handleSubmitModal() {
      this.item.isActive ? this.deactivateCoupon() : this.activateCoupon();
    },
    activateCoupon() {
      this.isSubmitting = true;
      window.API.activateCoupon(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("coupons.change-status.alert.activated", {
              title: this.item.title,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("coupons.change-status.alert.could-not-activate"),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    deactivateCoupon() {
      this.isSubmitting = true;
      window.API.deactivateCoupon(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("coupons.change-status.alert.deactivated", {
              title: this.item.title,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t(
              "coupons.change-status.alert.could-not-deactivate"
            ),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
